export default {
  // 菜单项
  home: "首页",
  helpCenter: "帮助中心",

  // 帮助中心子菜单
  productFunction: "产品功能介绍",
  nationalInvolvement: "司法判例参考",
  prosecuteBook: "起诉书",
  policyRegulation: "政策法规",
  blockchainKnowledge: "区块链行业知识",
  blockchainCaseInvestigation: "区块链案件侦查实录",

  // 数据大屏
  dataScreen: "数据大屏",

  // 用户下拉菜单
  userCenter: "用户中心",
  userFeedback: "用户反馈",
  logout: "退出登录",

  // 角色
  systemAdmin: "系统管理员",

  // 默认值
  noPhoneNumber: "暂无号码",
};
